const EntidadesFederativas = [
  {
    label: 'AGUASCALIENTES',
    value: '01'
  },
  {
    label: 'BAJA CALIFORNIA',
    value: '02'
  },
  {
    label: 'BAJA CALIFORNIA SUR',
    value: '03'
  },
  {
    label: 'CAMPECHE',
    value: '04'
  },
  {
    label: 'COAHUILA',
    value: '05'
  },
  {
    label: 'COLIMA',
    value: '06'
  },
  {
    label: 'CHIAPAS',
    value: '07'
  },
  {
    label: 'CHIHUAHUA',
    value: '08'
  },
  {
    label: 'DISTRITO FEDERAL',
    value: '09'
  },
  {
    label: 'DURANGO',
    value: '10'
  },
  {
    label: 'GUANAJUATO',
    value: '11'
  },
  {
    label: 'GUERRERO',
    value: '12'
  },
  {
    label: 'HIDALGO',
    value: '13'
  },
  {
    label: 'JALISCO',
    value: '14'
  },
  {
    label: 'MEXICO',
    value: '15'
  },
  {
    label: 'MICHOACAN',
    value: '16'
  },
  {
    label: 'MORELOS',
    value: '17'
  },
  {
    label: 'NAYARIT',
    value: '18'
  },
  {
    label: 'NUEVO LEON',
    value: '19'
  },
  {
    label: 'OAXACA',
    value: '20'
  },
  {
    label: 'PUEBLA',
    value: '21'
  },
  {
    label: 'QUERETARO',
    value: '22'
  },
  {
    label: 'QUINTANA ROO',
    value: '23'
  },
  {
    label: 'SAN LUIS POTOSI',
    value: '24'
  },
  {
    label: 'SINALOA',
    value: '25'
  },
  {
    label: 'SONORA',
    value: '26'
  },
  {
    label: 'TABASCO',
    value: '27'
  },
  {
    label: 'TAMAULIPAS',
    value: '28'
  },
  {
    label: 'TLAXCALA',
    value: '29'
  },
  {
    label: 'VERACRUZ',
    value: '30'
  },
  {
    label: 'YUCATAN',
    value: '31'
  },
  {
    label: 'ZACATECAS',
    value: '32'
  }
];

export default EntidadesFederativas;